"use strict";
class globalScript {
    constructor() {
        this.init();
    }
    init() {
        this.mobile_nav();
        this.hooper();
        this.common_scripts();
    }
    mobile_nav() {
        const nav_btn = document.querySelector('.hamburger');
        const mobile_nav = document.querySelector('.lixtick-menu .menu');
        nav_btn.addEventListener('click', function () {
            if (nav_btn.classList.contains('is-active') === true) {
                nav_btn.classList.remove('is-active');
                mobile_nav.classList.remove('nav-show');
            }
            else {
                nav_btn.classList.add('is-active');
                mobile_nav.classList.add('nav-show');
            }
        });
    }
    async common_scripts() {
        const { default: Stickyfill } = await import(
        /* webpackChunkName: 'Stickyfill' */ 'stickyfilljs');
        Stickyfill.add(document.querySelectorAll('.sticky'));
        if (document.querySelector('.object-fit')) {
            const { default: objectFitImages } = await import(
            /* webpackChunkName: 'objectFitImages' */ 'object-fit-images');
            objectFitImages('.object-fit');
        }
    }
    async hooper() {
        if (document.querySelector('.hooper-wrap')) {
            console.log('hooper');
            var { default: Hooper } = await import(
            /* webpackChunkName: 'Hooper' */ './components/hooper/hooper');
            if (document.querySelector('.hooper-index')) {
                Hooper.init('.hooper-index');
            }
        }
    }
}
new globalScript();
